export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_complete_3.3e5af466.jpg";